module.exports = __webpack_public_path__ + "media/images/logo-en-6a8849c750386a494d9058dafa0e5486.png";